import React, {useCallback} from 'react';
import {getOperatorLabel} from './getOperatorLabel';
import {isOperatorSelectorVisible} from './isOperatorSelectorVisible';

function OperatorSelector(props) {
    const {field, value, onChange} = props,
        {operators = []} = field ?? {};

    const handleChange = useCallback(
        e => {
            onChange(e.target.value);
        },
        [onChange]
    );

    if (!isOperatorSelectorVisible(field)) return null;

    if (operators.length == 1) {
        const operator = operators[0];
        return <div className="form-control-static">{getOperatorLabel(operator)}</div>;
    }

    return (
        <select className="form-control" value={value} onChange={handleChange}>
            {operators.map((operator, i) => (
                <option value={operator.id} key={i}>
                    {getOperatorLabel(operator)}
                </option>
            ))}
        </select>
    );
}

export default OperatorSelector;
